function ExitIcon(props) {
  return (
    <svg id='ExitIcon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 28.081 33.06' {...props}>
      <g id='Raggruppa_56' data-name='Raggruppa 56' transform='translate(-1754.416 -7.5)'>
        <path
          id='Tracciato_60'
          data-name='Tracciato 60'
          d='M1678.1,320h-17.182v32.06H1678.1'
          transform='translate(94 -312)'
          fill='none'
          stroke='#fff'
          strokeWidth='1'
        />
        <path
          id='Tracciato_62'
          data-name='Tracciato 62'
          d='M0,0H20'
          transform='translate(1761.5 23.5)'
          fill='none'
          stroke='#fff'
          strokeWidth='1'
        />
        <path
          id='Tracciato_61'
          data-name='Tracciato 61'
          d='M1683.994,326.119l7.075,9.77-5.838,7.228-1.237,1.531'
          transform='translate(90.799 -312)'
          fill='none'
          stroke='#fff'
          strokeWidth='1'
        />
      </g>
    </svg>
  )
}

export default ExitIcon
